import {Link, useLoaderData, useRouteLoaderData} from '@remix-run/react'
import React, {Fragment} from 'react'
import clsx from 'clsx'
import {slugToText} from '@roundforest/text-transforms-commons'
import {getDomainConfig} from '~/domains'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {IconRightArrowLightWeight} from '~/icons/home-page/brg-icon-app-logo-thick'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'

const RecommendedLists = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {newHomePageData} = useLoaderData() as CategoriesDataProps
  const {recommendedLists} = newHomePageData?.homepageData || {}
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'recommended-lists',
    widget_place: 'middle',
  })
  const reportWidgetClick = useReportWidgetClick()
  const displayItems = recommendedLists && recommendedLists.length > 1

  return (
    displayItems && (
      <div
        className={clsx('mx-auto flex flex-col gap-4', stylesBydomain.UTILS_MAIN_CONTAINER, 'utils_main_container')}
        ref={widgetRef}
      >
        <h3 className="text-center text-xl font-bold">{translations.Home.RecommendedLists.title}</h3>
        <div className="no-scrollbar flex flex-row justify-start gap-4 overflow-x-scroll">
          {recommendedLists?.map(({slug, image}, i) => {
            const categoryName = slugToText(slug)
            return (
              <Fragment key={`${i}-${slug}`}>
                <div className="flex min-h-52 w-full min-w-[166px] max-w-80 flex-col gap-2 rounded-lg bg-[#F5F5F5] p-3">
                  <div className="flex h-[105px] items-center justify-center bg-white p-2">
                    <img src={image} alt={categoryName} className="size-24 object-scale-down" loading="lazy" />
                  </div>
                  <div className="flex h-full flex-col justify-center gap-2">
                    <span className="text-base font-bold">{categoryName}</span>

                    <Link
                      to={`/${slug}`}
                      prefetch="intent"
                      aria-label={`view ${categoryName}`}
                      className="mt-auto flex flex-row gap-2 text-[13px] font-light text-[#494747] underline"
                      onClick={() =>
                        reportWidgetClick({
                          widget_name: 'recommended-lists',
                          widget_place: 'bottom',
                          trigger_type: categoryName,
                        })
                      }
                    >
                      {translations.Home.viewAll} <IconRightArrowLightWeight className="h-5 w-5" />
                    </Link>
                  </div>
                </div>
              </Fragment>
            )
          })}
        </div>
      </div>
    )
  )
}

export default RecommendedLists
